import { addDays, format } from 'date-fns';

const formatDeliveryDate = (deliveryDays: number | null) => {
  switch (deliveryDays) {
    case null:
    case undefined:
      return '';
    case 0:
      return 'Today';
    case 1:
      return 'Tomorrow';
    default:
      if (typeof deliveryDays === 'number') {
        return `${format(addDays(new Date(), deliveryDays), 'EEE do')}`;
      }
      return '';
  }
};

export const getDeliveryLabel = (
  deliveryDays: number | null,
  deliveryCost: number | null,
): string => {
  const deliveryDateLabel = formatDeliveryDate(deliveryDays);
  const hasDate = deliveryDateLabel.length > 0;
  const deliveryCostLabel = deliveryCost !== null && deliveryCost === 0 ? 'Free' : '';
  const hasCost = deliveryCostLabel.length > 0;

  if (!hasDate && !hasCost) {
    return '';
  }

  if (hasDate && hasCost) {
    return `Get it by <b>${deliveryDateLabel} · ${deliveryCostLabel}</b>`;
  }

  if (hasDate) {
    return `Get it by <b>${deliveryDateLabel}</b>`;
  }

  return `<b>${deliveryCostLabel} delivery</b>`;
};
